import { Link } from 'react-router-dom';
import { ArrowRight, Phone } from 'lucide-react';
import { Button } from '@dreamtree-org/twreact-ui';
import { useCompany, useSettings } from '@site/content';

export default function CtaBand() {
  const company = useCompany();
  const { cta } = useSettings();
  return (
    <section className="px-4 py-16 sm:px-8 sm:py-24" aria-labelledby="cta-heading">
      <div className="relative mx-auto max-w-7xl overflow-hidden rounded-[2rem] bg-ink-950 px-6 py-14 text-white sm:px-16 sm:py-16">
        <div className="absolute inset-y-0 right-0 w-2/3 bg-[radial-gradient(ellipse_at_bottom_right,rgba(245,144,11,0.55),rgba(229,62,65,0.35)_40%,transparent_70%)]" aria-hidden="true" />
        <div className="relative grid items-center gap-8 lg:grid-cols-[1.5fr_1fr]">
          <div>
            <h2 id="cta-heading" className="text-balance text-3xl leading-[1.05] sm:text-5xl">{cta.title}</h2>
            <p className="mt-4 max-w-xl text-pretty text-ink-300">{cta.text}</p>
          </div>
          <div className="flex flex-col gap-3 sm:flex-row lg:flex-col lg:items-end">
            <Button as={Link} to="/contact" size="lg" className="!bg-primary-600 hover:!bg-primary-500" rightIcon={<ArrowRight className="h-5 w-5" />}>
              {cta.buttonLabel}
            </Button>
            <Button as="a" href={company.phoneHref} size="lg" variant="outline" className="!border-white/30 !text-white hover:!bg-white/10" leftIcon={<Phone className="h-5 w-5" />}>
              {company.phone}
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
